<template>
  <div class="flex flex-col items-center tablet:items-start
    pt-5 tablet:pt-8
  ">
        <div class="tablet:pl-5">
            <img src="@/assets/logo-red.svg" class="h-10 tablet:h-12" />
        </div>

        <div class="hidden tablet:block mt-8 tablet:pl-5">
            <p>Welcome</p>
            <router-link class="font-bold" to=''>Asad A</router-link>
        </div> <!-- User panel -->

        <div id="nav" class="flex flex-col w-full mt-8 items-center
        text-grey-light tablet:items-start">
            <!-- TODO: navigation should come from vuex and depending on user role -->

            <router-link
            class="menu-item font-medium text-xl tablet:text-base tablet:pl-5"
            :to="{name: 'community.index'}">
                <i class="fab fa-slack-hash tablet:pr-2"></i>
                <span class="hidden tablet:inline">Community</span>
            </router-link>

            <router-link
            class="menu-item font-medium font-medium text-xl tablet:text-base tablet:pl-5"
            :to="{name: 'requests.index'}">
                <i class="fas fa-tools tablet:pr-2"></i>
                <span class="hidden tablet:inline">Service request</span>
            </router-link>

            <router-link
            class="menu-item text-xl tablet:text-base tablet:pl-5 font-medium"
            :to="{name: 'residents.index'}">
                <i class="fas fa-user tablet:pr-2"></i>
                <span class="hidden tablet:inline">Residents</span>
            </router-link>

            <router-link
            class="menu-item text-xl tablet:text-base tablet:pl-5 font-medium"
            :to="{name: 'devices.index'}">
                <i class="fas fa-laptop-code tablet:pr-2"></i>
                <span class="hidden tablet:inline">Devices</span>
            </router-link>

            <router-link
            class="menu-item text-xl tablet:text-base tablet:pl-5 font-medium"
            :to="{name: 'visitors.index'}">
                <i class="fas fa-eye tablet:pr-2"></i>
                <span class="hidden tablet:inline">Visitors</span>
            </router-link>

            <router-link
            class="menu-item font-medium text-xl tablet:text-base tablet:pl-5 tablet:pr-2"
            :to="{name: 'settings.index'}">
                <i class="fa fa-cog tablet:pr-2"></i>
                <span class="hidden tablet:inline">Settings</span>
            </router-link>

            <a href="#" @click.prevent="logout()"
            class="menu-item font-medium text-xl tablet:text-base tablet:pl-5 tablet:pr-2">
                <i class="fa fa-sign-out-alt"></i>
                <span class="hidden tablet:inline">Logout</span>
            </a>
        </div>
  </div>
</template>

<script>
export default {
    name: 'Header',
    data() {
        return {
            logo: this.$store.getters['appModule/logo']
        }
    },
    methods: {
        logout() {
            // TODO: clear all localStorage, cookies and vuex user data
        }
    }
};
</script>

<style lang="scss" scoped>
.menu-item {
    @apply py-2 font-nunito text-grey-light my-0;
}

#nav .active {
    @apply text-red;
}
</style>
